import(/* webpackMode: "eager" */ "D:\\Aarav\\Projects\\relaxing-routine\\app\\classes\\page.tsx");
